// extracted by mini-css-extract-plugin
export default {"formIcon":"Icons__formIcon--18p","hideIcon":"Icons__hideIcon--3Qj"};